import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { isEmpty, returnEmpty } from '@core/_utils/tools.utils';
import { CheckTools } from '@service/check.tools';
import { RequestTools } from '@service/request.tools';
import { AuthService } from '@auth/auth.service';

@Component({
    selector: 'page-reset-pwd',
    templateUrl: './page-reset-pwd.component.html',
    styleUrls: ['./page-reset-pwd.component.scss'],
})
export class PageResetPwdComponent implements OnInit {
    public passWord = '';
    public passWordConf = '';
    public passWordOld = '';

    constructor(
        public menu: MenuServiceInt,
        private router: Router,
        protected _messageService: MessagesService,
        private auth: AuthService,
        private requestTools: RequestTools,
        private checkTools: CheckTools,
        private translate: TranslateService
    ) {
        this.menu.display = false;
    }

    ngOnInit() {}

    public checkPassWrd() {
        if (this.checkPass(this.passWordOld, this.passWord, this.passWordConf) === false) {
            return;
        }
        this.sendPassWrd();
    }

    public async sendPassWrd() {
        let wRes: any;
        let wMess: string;
        wRes = await this.execSendPassWrd(this.passWord, this.passWordOld);
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            wMess = returnEmpty(wRes.Message);
            if (wMess !== '') {
                this.checkTools.check.msg = wMess;
            }
            this._messageService.addErrorMsg(this.checkTools.getMsg(), this.translate.instant('Pass_KO'));
            return;
        } else {
            this.auth.clearStorage();
            this.router.navigate(['login']);
        }
    }

    private async execSendPassWrd(aPassWord, aPassWordOld) {
        let wRes: any;
        let wRequest;
        let wCommon;
        wCommon = {
            Password: aPassWord,
            OldPass: aPassWordOld,
        };
        if (this.auth.isAdmin() === true) {
            wRequest = {
                ...wCommon,
                General: {
                    General: {
                        AdminPassword: aPassWord,
                    },
                },
            };
        } else {
            wRequest = {
                ...wCommon,
                AutoGenerated: this.auth.isAutoGenerated(),
            };
        }
        wRes = await this.requestTools.execUrlAction('setpass', wRequest);
        return wRes;
    }

    private checkPass(aOldPass, aPass, aPassConf) {
        if (isEmpty(aPass)) {
            this._messageService.addErrorMsg(this.translate.instant('Pass_KO_1'));
            return false;
        }
        if (aPass !== aPassConf) {
            this._messageService.addWarn(this.translate.instant('Pass_KO_2'));
            return false;
        }
        if (aOldPass === aPass) {
            this._messageService.addWarn(this.translate.instant('Pass_KO_3'));
            return false;
        }
        return true;
    }
}
